import { useAccordion, useAccordionItem } from './useAccordion';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { Button } from '@osmosis/react-ui/components/Button';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { P } from '@osmosis/react-ui/components/Text';
import * as motion from 'motion/react-m';

/**
 * AccordionButton.
 */
export const AccordionButton = ({
  children,
  index,
  testID = 'accordion-button',
}: {
  children: string;
  index?: number;
  testID?: string;
}) => {
  const { setItem } = useAccordion();
  const isOpen = useAccordionItem(index as any); // FIXME: any

  return (
    <Button
      data-testid={testID}
      variant="transparent"
      onClick={() => {
        setItem(index as any); // FIXME: any
      }}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <P>{children}</P>
      <motion.div
        animate={{
          rotate: isOpen ? 180 : 0,
        }}
      >
        <Icon icon={faChevronDown} />
      </motion.div>
    </Button>
  );
};
